import dayjs from "dayjs";

export default function calcularTempoEmEspera(data_inicio) {
  if (!data_inicio) return "0 minuto(s)";

  const inicio = dayjs(data_inicio.replace(" ", "T")).add(3, "hour");

  if (!inicio.isValid()) {
    return "0 minuto(s)";
  }

  const minutos = dayjs().diff(inicio, "minute");

  if (minutos <= 0) return "0 minuto(s)";

  const horas = Math.floor(minutos / 60);
  const minutosRestantes = minutos % 60;

  return horas > 0
    ? `${horas} hora(s) e ${minutosRestantes} minuto(s)`
    : `${minutos} minuto(s)`;
}